import React, { Component } from 'react';
import {Link} from 'react-router-dom';

import '../html-template/select-showcards.scss';

class SelectShowCard extends Component {
    constructor(props){
        super(props);
			this.state = {
				questions: [
					{
						name: "Q31",
						folder: "q31",
						num_of_cards: 6,
						per_page: 1
					},
					{
						name: "Q32",
						folder: "q32",
						num_of_cards: 39,
						per_page: 1
					},
					{
						name: "Q33",
						folder: "q33",
						num_of_cards: 6,
						per_page: 1
					}
				]
			};
		}

    render(){
			const { questions } = this.state;
        return (
        <main className="container select-tool">
            <div className="content-wrapper">
                <div className="content-right-wrapper survey">
									<div className="questions">
										{
											questions.map((q) => 
												<Link to={"/show-cards/"+q.folder} className="question">
													{q.name}
												</Link>
											)
										}
									</div>
                </div>
            </div>
        </main>
        );
    }
}

export default SelectShowCard;
